import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import shiftPageHero from '../../assets/images/shift-page-hero-mookata.jpg';
import {Link} from "react-router-dom";
import config, {AIRTABLE_HOOKS_ROOT, API_ROOT} from "../../config";


class ShiftPageMookata extends Component {
  componentDidMount() {
    window.analytics.page("Shift");
  }

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles('Fusion Mookata')}
          {metaDescriptions('Server for Fusion Mookata on Sun, July 22nd from 5:00PM to 10:00PM in Punggol. SGD 9 per hour.')}
          {metaImages(`${window.location.origin}${shiftPageHero}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <a href={'https://www.singleshift.sg/pros'}>
                  <img className="logo" src={logoBlack}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Image */}
        <div id='hero'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <img src={shiftPageHero} className='img-fluid' width='940'/>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Information */}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h1 className={classes.shiftName}>Fusion Mookata</h1>
              <p className={classes.shiftDate}>Sun, July 22nd from 5:00PM to 10:00PM</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Wage</h3>
              <p className={classes.shiftWage}>SGD 9 per hour</p>
            </div>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Job Type</h3>
              <p className={classes.shiftJob}>Server</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Address</h3>
              <p className={classes.shiftAddress}>Punggol (<a href="https://goo.gl/maps/N84D88SHRJ22" target="_blank">3 Punggol Point Road, #01-11/12 The Punggol Settlement, 828694</a>)</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>About Fusion Mookata</h3>
              <p>Fusion Mookata offers some of the best Asian and Western Cuisine serving a tantalising collection of dishes that are suitable for family, large groups, catching up with friends and colleagues.</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Attire</h3>
              <p>Black Top, Covered Shoes</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Duties</h3>
              <p>Typical Service Crew</p>
            </div>
          </div>
        </div>

        {/* Shift Actions*/}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Have an account?</h3>
                <p>Reply YES to the SMS you received.</p>
              </div>
            </div>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Don't have an account?</h3>
                <a href={'https://www.singleshift.sg/pros'}>Sign up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default withStyles((theme) => ({
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftPageMookata);



// WEBPACK FOOTER //
// ./src/pages/shift-pages/ShiftPageMookata61.js